import { render, staticRenderFns } from "./ReportedChecklists.vue?vue&type=template&id=264a52a7"
import script from "./ReportedChecklists.vue?vue&type=script&lang=ts"
export * from "./ReportedChecklists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports